import { type ECommerceV2Apis } from '@dni-types/api-definitions/ecommerce-v2'
import { createMutationHelper } from '@utils/swr'
import { type UpdateUserPaymentTokenRequest } from '../types/apiRequest'
import { type WpUserPaymentTokenResponse } from '../types/apiResponse'

export const {
  useMutation,
} = createMutationHelper<ECommerceV2Apis['put']['updateUserAddresses'], WpUserPaymentTokenResponse, UpdateUserPaymentTokenRequest>({
  client: 'eCommerceV2',
  key: '/:country_code/user/payment_tokens/:token_id',
  fetcher: (_url, { arg, client }) => {
    return client.put(`/${arg.country_code}/user/payment_tokens/${arg.token_id}`, { cardholder: arg.cardholder })
  },
})
export const useApiECommerceUpdateUserPaymentToken = useMutation
